import(/* webpackMode: "eager" */ "/codebuild/output/src4014678918/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
